import React from 'react';
import classnames from 'classnames';

import './index.less';

interface IProps {
  loading: boolean;
}

function Index({ loading = false }: IProps) {
  return (
    <div className={classnames('spinner-wrapper', {
      'spinner-hidden': !loading ? true : false
    })}>
      <div className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
    </div>
  )
}

export default Index;
